module.exports = __webpack_public_path__ + "img/Product-A4-Book.ec69ade8.png";